module.exports = __webpack_public_path__ + "img/2.815aded4.jpg";